import { ApiUtil } from '@/shared/api';

export const publishedUserApi = {
    /** 발행함 - 회원정보 등록 */
    postIntegPubUser: (param: API.IntegPubUser.Req) => {
        return ApiUtil.post<API.IntegPubUser.Res>('/integ/pub/user', param);
    },
};
